import React, { Component } from 'react';
import config from './config';
import trackingEvent from './TrackingEvents';
// import { motion } from "framer-motion";

import TopBarDrawer from './TopBarDrawer';
import AdGrid from './AdGrid';

const MapList = React.lazy(() => import('./MapList'));

export default class Dashboard extends Component{

    constructor(props) {
        super(props)

        var redirectTo = '';
        if(localStorage.getItem('redirectTo')!==undefined && localStorage.getItem('redirectTo')!==""){
            if(localStorage.getItem('redirectTo')==='timeline'){
                redirectTo = '/my-timeline/';
            }else if(localStorage.getItem('redirectTo')==='coupon'){
                redirectTo = '/ads-mark-as-read/'+localStorage.getItem('redirectId');
            }else if(localStorage.getItem('redirectTo')==='wallet'){
                redirectTo = '/wallet';
            }
            if(redirectTo!==""){
                this.props.history.push({
                    pathname: redirectTo,
                    state: { }
                });
            }
            localStorage.removeItem('redirectTo');
            localStorage.removeItem('redirectId');
        }

        trackingEvent.customActionEvent(trackingEvent.offer_loaded);
    }

    render(){ 
        var classNamesList = 'AppContent';
        if(this.props.location.pathname==='/map'){
            classNamesList = classNamesList + ' isMapView';
        }else{
            classNamesList = classNamesList + ' adGridView isInfiniteScroll';
        }

        // console.log(this.props.location.pathname);
        return(
            //  <motion.div
            <div
                initial="initial"
                animate="in"
                exit="out"
                variants={config.pageAnimation}
                transition={config.pageTransition}
                >
                <div className="AppDashboard">
                    <div className="topAndSideBar">
                        <TopBarDrawer isHome="true" strTitle="Dashboard"/>
                    </div>

                    <div className={classNamesList}>
                        {this.props.location.pathname==='/map'?
                            <React.Suspense fallback={<div className="route-loading">Loading...</div>}>
                                <MapList history={this.props.history}/>
                            </React.Suspense>
                        :
                            <AdGrid history={this.props.history}/>
                        }
                    </div>
                </div>
            {/* </motion.div> */}
            </div>
        )
    }
}
